import { render, staticRenderFns } from "./PayoneerSecond.vue?vue&type=template&id=a486557e&scoped=true"
import script from "./PayoneerSecond.vue?vue&type=script&lang=js"
export * from "./PayoneerSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a486557e",
  null
  
)

export default component.exports